module.exports = __webpack_public_path__ + "img/logos_customer_09.71156a25.svg";